import React from "react";

function Radkaat() {
  return (
    <div className="w-full mx-auto space-y-5">
      {/* Brand Intro */}
      <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Radkaat</h1>
        <p className="text-gray-700 leading-relaxed text-base">
          <strong>Radkaat</strong> is more than a logo—it’s a flag carried
          through heat, mud, and monsoon. Born in Shimla, Radkaat was created
          out of necessity: gear designed for the Indian outdoors. Raw, real,
          and rooted, every product is made for those who feel most alive under
          open skies. Proudly Indian, Radkaat is forged by the wild, crafted for
          resilience, and guided by the spirit of “<strong>Nothing But Now</strong>.”
        </p>
      </div>

      {/* Our Story */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">Our Story</h2>
        <p className="text-gray-700 text-sm leading-relaxed">
          From the hills of Shimla to the heart of the outdoors, Radkaat began
          with a simple question: “Why doesn’t gear feel like it was made for
          us?” The name “Radkaat,” once used to describe a vagabond wild-child,
          became a symbol of resilience. Today, Radkaat builds gear that is raw,
          real, and proudly Indian—made for heat, mud, monsoon, and madness.
        </p>
      </div>

      {/* Manifesto */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">Our Manifesto</h2>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-2">
          <li>We move with purpose and pride.</li>
          <li>We stand for more than ourselves.</li>
          <li>
            The Himalayas are our playground, the world our canvas, and Mother
            Nature our compass.
          </li>
          <li>We don’t stand still—we move forward, together.</li>
        </ul>
      </div>

      {/* Product Line */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">Products</h2>
        <p className="text-gray-700 text-sm mb-1">
          Radkaat products are designed for movement and built for India. Clean,
          functional, and proudly disruptive—our lineup blends form, function,
          and a silhouette that speaks without shouting.
        </p>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-1">
          <li>Apparel & Outdoor Gear</li>
          <li>Climbing & Adventure Equipment</li>
          <li>Minimal, functional Packaging</li>
          <li>Team Gear reflecting the Radkaat spirit</li>
        </ul>
      </div>

      {/* Key Highlights */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Key Highlights
        </h2>
        <ul className="list-none space-y-3 text-gray-700 text-sm">
          <li>
            <strong className="text-gray-900">Born in Shimla:</strong> Every
            product pays tribute to its origins.
          </li>
          <li>
            <strong className="text-gray-900">Global Reach:</strong> A homegrown
            Indian brand gaining recognition worldwide.
          </li>
          <li>
            <strong className="text-gray-900">Nothing But Now:</strong> A call
            to live raw, real, and rooted in the moment.
          </li>
          <li>
            <strong className="text-gray-900">Bold & Authentic:</strong> Radkaat
            challenges convention with clarity and pride.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Radkaat;
